import { BasicFrame } from 'components/organisms';
import { frameConfigBasicTink } from '../../AppConfig';
import { LightbulbIcon } from 'components/icons';
import { routes } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from 'components/atoms/Card/Card';
import Link from 'components/atoms/Link/Link';
import styles from './TinkBankNA.module.scss';

export default function TinkBankNA() {
  const { t } = useTranslation('tinkBankNA');
  const navigate = useNavigate();

  const onFooterLinkHandler = () => {
    navigate(routes.FirstLoan_OnlineBank_Verify);
  };

  const onDocCardHandler = () => {
    navigate(
      `${routes.FirstLoan_Manual_Upload}?backRoute=${routes.firstLoan_tink_bank_na}`,
    );
  };

  const onLaterCardHandler = () => {
    navigate(routes.firstLoan_tink_later);
  };

  return (
    <BasicFrame
      {...frameConfigBasicTink}
      headerLayout="centered"
      onBackBtnHandler={() => navigate(routes.FirstLoan_OnlineBank_Verify)}
    >
      <div className={styles.layout} data-test="tinkBankNA-layout">
        <div className={styles.title} data-test="tinkBankNA-title">
          {t('title')}
        </div>
        <Card className={styles['doc-card']} data-test="tinkBankNA-docCard">
          <div
            className={styles.content}
            data-test="tinkBankNA-docCard-content"
          >
            {t('docCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankNA-button"
            onClick={onDocCardHandler}
          >
            {t('docCard.cto')}
          </button>
        </Card>
        <Card className={styles['later-card']} data-test="tinkBankNA-laterCard">
          <div
            className={styles.heading}
            data-test="tinkBankNA-laterCard-heading"
          >
            <LightbulbIcon data-test="tinkBankNA-laterCard-lightbulb" />
            <div
              className={styles.title}
              data-test="tinkBankNA-laterCard-title"
            >
              {t('laterCard.title')}
            </div>
          </div>
          <div
            className={styles.content}
            data-test="tinkBankNA-laterCard-content"
          >
            {t('laterCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankNA-laterCard-button"
            onClick={onLaterCardHandler}
          >
            {t('laterCard.cto')}
          </button>
        </Card>
        <div className={styles.footer} data-test="tinkBankNA-footer">
          {t('footer')}
        </div>
        <Link
          className={styles['footer-link']}
          data-test="tinkBankNA-footer-link"
          onClick={onFooterLinkHandler}
        >
          {t('footerLink')}
        </Link>
      </div>
    </BasicFrame>
  );
}
